import { Component, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { LoginService } from '../login/login.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../header-pages/change-password/change-password.component';
import { LabPrinterComponent } from '../header-pages/lab-printer/lab-printer.component';
import { PrivacyPolicyComponent } from '../header-pages/privacy-policy/privacy-policy.component';
import { SupportComponent } from '../header-pages/support/support.component';
import { LabSetupService } from '../lab-admin/lab-setup/lab-setup.service';
import { OrdersService } from '../accession/orders/orders.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnInit {
  appDrawerOpen = false;

  sideMenu = [];
  currentUser: any;
  breadcrumbHistory = [];
  currentPath = '';
  logo = '';
  errorMessage: string = '';
  displayErrors: boolean = false;
  homeUrl : string;
  businessName = '';
  notificationListCount = 0;
  notificationListTestOnHoldCount = 0;
  newDrugsCount = 0;
  totalNotification = 0;
  notificationInterval: any;
  notificationIcon = false;
  manualLink = '../../../assets/images/RevDxManual.pdf';

  constructor(
    public sharedService: SharedService,
    public labSetupService: LabSetupService,
    private loginService: LoginService,
    private router: Router,
    public location: Location,
    private dialog: MatDialog,
    private ordersService: OrdersService,
  ) {

    // subcribe to router event
    this.router.events.subscribe(event => {

      if (event instanceof ActivationEnd) {

        this.currentPath = location.path();
        if (location.path() == '/dashboard') {
          this.sharedService.removeDataFromStorage('breadcrumbHistory');
          this.breadcrumbHistory = [];
        }
        else {
          if (event.snapshot.data.headerName) {
            let history = this.sharedService.getBreadcrumbHistory();

            if (history) {
              history = history.filter(element => element.name !== event.snapshot.data.headerName);
            }
            else {
              history = [];
            }

            history.push({ name: event.snapshot.data.headerName, url: String(location.path()) });
            this.sharedService.setDataToStorage('breadcrumbHistory', history);
            this.breadcrumbHistory = this.sharedService.getBreadcrumbHistory();
            this.breadcrumbHistory = this.breadcrumbHistory.slice(Math.max(this.breadcrumbHistory.length - 5, 0));
          }
        }
        this.sideMenu = this.sharedService.setMainMenu();
      }
    });

    if (this.sharedService.hasPermission('notifications'))
    {
      this.getReminderAvailability();
      clearInterval(this.notificationInterval);
      this.notificationInterval = setInterval(() => {  this.getReminderAvailability(); }, 300000);
    }

    if (this.sharedService.currentUser.LabclientId > 0)
    {
      this.getBusinessName(this.sharedService.currentUser.LabclientId);
    }
  }

  ngOnInit(): void {
    this.currentUser = this.sharedService.currentUser;
    this.getLabImage();
    this.setHomePage();
  }

  getLabImage() {
    this.labSetupService.getLab(this.currentUser.LabId).subscribe(res => {
      this.logo = res.fileData;
    });
  }

  getBusinessName(labclientId) {
    this.ordersService.getSelectedSpecialityType(labclientId).subscribe(res => {
        this.businessName = res.businessName;
    });
  }

  moveToPage(item) {
    this.router.navigateByUrl(item.url);
  }

  userLogOut() {
    this.loginService.userLogOut().subscribe(res => {
      if (res) {
        this.sharedService.resetAllData();
        this.router.navigate(['/login']);
      }
    });
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '30%',
      disableClose: true,
      data: {
        title: 'Reset Password',
        userId: this.sharedService.currentUser.Id,
      }
    });
  }

  labPrinter() {
    const dialogRef = this.dialog.open(LabPrinterComponent, {
      width: '30%',
      disableClose: true
    });
  }

  privacyPolicy() {
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
      width: '80%',
      data: { url: '../../../assets/images/PrivacyPolicy.pdf' }
    });
  }

  manual() {
    if(this.sharedService.currentUser.LabclientId > 0)
    {
      this.manualLink = '../../../assets/images/RevDxClientPortalManual.pdf';
    }
    else if(this.sharedService.currentUser.SalesRepId > 0)
    {
      this.manualLink = '../../../assets/images/RevDxSalesRepManual.pdf';
    }
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
      width: '80%',
      data: { url: this.manualLink }
    });
  }

 
  support() {
    const dialogRef = this.dialog.open(SupportComponent, {
      width: '80%',
    });
  }

  menuChange(flag) {
    this.appDrawerOpen = flag;
  }

  expanMenu(child) {
    if (child && child.length > 0) {
      try {
        const tmp = child.find(m => m.url == window.location.pathname);
        if (tmp) {
          return true;
        } else {
          return false;
        }
      } catch {
        return false;
      }
    }
    return false;
  }

  setHomePage() {
    this.homeUrl = this.sharedService.currentUserRole.admin ? "/dashboard" : "/accession/orders"
  }

  getReminderAvailability()
  {
    if (this.sharedService.hasPermission('notifications'))
    {
      const userInfo = this.sharedService.currentUser;
      if (userInfo.LabclientId > 0)
    {
        this.notificationIcon = false;
    }
    else if (userInfo.LabclientId == 0){
      this.labSetupService.getRemindersAvailability().subscribe((res: any) => {
        this.notificationListCount = res.totalRecords;
        if (this.notificationListCount > 0)
        {
            this.notificationIcon = true;
        }
       // this.getReminderAvailabilityForHoldQueue();
        this.getReminderAvailabilityForNewDrugs();

       // this.totalNotification = this.notificationListCount + this.notificationListTestOnHoldCount + this.newDrugsCount;
      });
    }
    }
  }

  getReminderAvailabilityForHoldQueue(){
    this.labSetupService.getRemindersAvailabilityForHoldQueue().subscribe((res: any) => {
      this.notificationListTestOnHoldCount = res.totalRecords;
      if (this.notificationListTestOnHoldCount > 0)
      {
          this.notificationIcon = true;
      }
    });
  }

  getReminderAvailabilityForNewDrugs(){
    this.labSetupService.getNewDrugList().subscribe((res: any) => {
      this.newDrugsCount = res.length;
      if (this.newDrugsCount > 0)
      {
          this.notificationIcon = true;
      }
    });

  }
  redirectToReminder(){
    this.notificationIcon = false;
    this.router.navigate(['/accession/reminder']);
  }

}
